import { render, staticRenderFns } from "./VehicleRequestNew.vue?vue&type=template&id=5f664c0e"
import script from "./VehicleRequestNew.vue?vue&type=script&lang=js"
export * from "./VehicleRequestNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports